import constant from "../_config/constant";
import { authHeader } from "../_helpers";
import { handleResponse } from "../_helpers/utils";


function trackdatalist(query) {
    const requestOptions = {
        method: "GET",
        headers: { ...authHeader(), "Content-Type": "application/json" },
      };
      return fetch(
        `${constant.apiUrl}/usertrack?${new URLSearchParams(query).toString()}`,
        requestOptions
      )
        .then(handleResponse)
        .then((usertrack) => {
          return usertrack;
        });
  }

  export const userTrackService = {

    trackdatalist,
  };